import CountryOptions from '../../constants/CountryOptions'

export default class VcardExporter {
  header () {
    let result = this.line(['BEGIN'], ['VCARD'])
    result += this.line(['VERSION'], ['2.1'])

    return result
  }

  footer () {
    let result = this.line(['REV'], [ this.date() ])
    result += this.line(['END'], ['VCARD'])

    return result
  }

  date () {
    return new Date().toISOString().replace(/[-:]/g, '').substring(0, 15) + 'Z'
  }

  collection (items) {
    return items.join(';')
  }

  line (field, value) {
    return this.collection(field) + ':' + this.collection(value) + '\r\n'
  }

  export (model) {
    let countries = CountryOptions.filter((option) => {
      return option.value === model.values.country
    })
    let country = countries ? countries[0] : null

    let result = this.header()

    result += this.line(['N'], [ [ model.values.lastname, model.values.suffix ].join(' '), model.values.forenames, '', '', model.values.nickname ])
    result += this.line(['FN'], [ model.getTitle() ])
    // result += this.line(['PHOTO', 'ENCODING=b', 'TYPE=JPEG'], [ model.getImage() ])
    result += this.line(['TEL', 'HOME', 'VOICE'], [ model.values.phone ])
    result += this.line(['TEL', 'HOME', 'CELL'], [ model.values.mobile ])
    result += this.line(['ADR', 'HOME'], [ '', model.values.address, '', model.values.city, model.values.region, model.values.zipcode, country ? country.label : '' ])
    result += this.line(['EMAIL'], [ model.values.email ])

    result += this.footer()

    return result
  }
}



// WEBPACK FOOTER //
// ./js/modules/person/exporters/VcardExporter.js